import './view.scss';

document.addEventListener("DOMContentLoaded", function() {
    var banner = document.getElementById('sitewide-banner');
    var closeButton = document.getElementById('close-banner');

    // Check if the banner and close button exist in the DOM
    if (banner && closeButton) {
        // Check if the cookie exists before displaying the banner
        if (getCookie('STYXKEY_hideBanner')) {
            banner.style.display = 'none'; // Hide the banner if cookie is set
        } else {
            banner.style.display = 'block'; // Show the banner if no cookie is set
        }

        // Add click event to the close button
        closeButton.addEventListener('click', function() {
            const moveFocus = banner.contains(document.activeElement);
            banner.style.display = 'none'; // Hide the banner
            setCookie('STYXKEY_hideBanner', 'true', 7); // Set a cookie to hide the banner for 7 days


            if (moveFocus) {
                const visibleLink = [...document.querySelectorAll('#super-nav a[href]')]
                    .find(link => link.getClientRects().length && getComputedStyle(link).visibility !== 'hidden');
                (visibleLink || document.getElementById('logo'))?.focus();
            }
        });
    }

    // Function to set a cookie
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    // Function to get a cookie
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
});
